// @flow
import styled from 'styled-components';
import Modal from 'reboron/OutlineModal';

export const StyledModal = styled(Modal)`
  max-width: 100%;
`;

export const ModalTitle = styled.h2`
  margin: 0px;
  font-family: ${props => props.theme.fontBold};
  margin-bottom: 20px;
`;

export const ModalContent = styled.p``;

export const ModalInner = styled.div`
  padding: 50px;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/components/modal/modal.styles.js